/* Copyright (c) 2019-2021, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { LocaleConfig } from 'libraries/crimson/src/lib/locale-service/locale.config';

const defaultLocale = 'en_US';

const localeConfig: LocaleConfig = {
    supportedLang: [
        'bg_BG',
        'cs_CZ',
        'da_DK',
        'de_DE',
        'el_GR',
        'en_GB',
        'en_US',
        'es_ES',
        'es_MX',
        'fi_FI',
        'fr_FR',
        'hr_HR',
        'hu_HU',
        'it_IT',
        'ja_JP',
        'ko_KR',
        'nb_NO',
        'nl_NL',
        'pl_PL',
        'pt_BR',
        'pt_PT',
        'ro_RO',
        'ru_RU',
        'sk_SK',
        'sl_SI',
        'sv_SE',
        'th_TH',
        'tr_TR',
        'uk_UA',
        'zh_CN',
        'zh_TW',
        'ar_SA'
    ]
};

export { localeConfig, defaultLocale };
